// extracted by mini-css-extract-plugin
export default {"greenBadge":"payment_greenBadge__GosCA","infoBadge":"payment_infoBadge__EimLo","dangerBadge":"payment_dangerBadge__tWCs6"};